import React, { FC } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import {
  ActionButton,
  LinkButton,
  MessageCard,
  PageHeader,
  UserStateComponent,
} from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, isLogicError, useFetcher } from '../../utils';
import { LogicError } from '../../utils/errorHandling';

export const RoleInviteCode: FC = () => {
  const { ts } = useTranslation();
  const match = useRouteMatch<{ code: string }>();
  const history = useHistory();

  const fetcher = useFetcher(async () => {
    return await api.getInvite(match.params.code);
  }, [match.params.code]);

  if (!fetcher.success) {
    if (fetcher.error && isLogicError(fetcher.error, LogicError.RoleInviteExpired)) {
      return (
        <UserStateComponent>
          <MessageCard icon="face" id="inviteExpired" level="warning">
            {ts('role_invite_code_expired')}
          </MessageCard>
        </UserStateComponent>
      );
    }

    if (isLogicError(fetcher.error, LogicError.RoleInviteMaxUses)) {
      return (
        <UserStateComponent>
          <MessageCard icon="face" id="inviteExpired" level="warning">
            {ts('role_invite_code_expired')}
          </MessageCard>
        </UserStateComponent>
      );
    }

    return <Fetcher result={fetcher} />;
  }

  const { data } = fetcher;

  return (
    <UserStateComponent>
      <PageHeader>{ts('role_invite_code')}</PageHeader>
      <Row className="justify-content-center">
        <Col lg={6} xs={12}>
          <Card>
            <CardBody className="text-center">
              <p>{ts('invited_to_join', data.role.name, data.role.description)}</p>
              <p>
                {data.userHasRole ? (
                  <Button className="btn btn-danger" disabled>
                    {ts('already_have_role')}
                  </Button>
                ) : (
                  <ActionButton
                    action={async () => {
                      await api.acceptInvite(data.role.id, data.inviteId, data.code);
                    }}
                    color="primary"
                    id="acceptRoleInvite"
                    onSuccess={(): void => {
                      history.push('/');
                    }}
                  >
                    {ts('accept_invite_action')}
                  </ActionButton>
                )}
                <LinkButton className="btn btn-secondary ml-2" to="/">
                  {ts('decline_invite_action')}
                </LinkButton>
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </UserStateComponent>
  );
};
